export * from "./losApi";
// export * from "./panApi";
export * from "./utmApi";
// export * from "./esignApi";
// export * from "./addressApi";
// export * from "./mandateApi";
// export * from "./customerApi";
// export * from "./dashboardApi";
// export * from "./documentsApi";
// export * from "./applicationApi";
// export * from "./workDetailsApi";
// export * from "./officialEmailApi";
// export * from "./fetchImageCkycApi";
// export * from "./applicationConfigAPI";
